import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import { getAuth0Config } from '../utils/config';

interface Auth0ConfigType {
  domain: string;
  clientId: string;
  audience: string;
  redirectUri: string;
}

/**
 * Pages that receive ANOTHER provider's OAuth response (?code=…&state=…).
 * The SDK treats any such URL as its own login callback, fails the state
 * check and restarts the Auth0 login, so it must leave these alone.
 */
const NON_AUTH0_CALLBACK_PATHS = ['/marketplace/verification/callback'];

const Auth0ProviderConfig: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth0Config = getAuth0Config() as Auth0ConfigType;

  const domain = auth0Config.domain || process.env.REACT_APP_AUTH0_DOMAIN || '';
  const clientId = auth0Config.clientId || process.env.REACT_APP_AUTH0_CLIENT_ID || '';
  const audience = auth0Config.audience || process.env.REACT_APP_AUTH0_SPA_AUDIENCE || '';
  const redirectUri = auth0Config.redirectUri || process.env.REACT_APP_REDIRECT_URI || window.location.origin;

  if (!domain || !clientId) {
    return <>{children}</>;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: audience || undefined,
        scope: 'openid profile email offline_access',
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      skipRedirectCallback={NON_AUTH0_CALLBACK_PATHS.includes(window.location.pathname)}
      onRedirectCallback={(appState) => {
        if (appState?.returnTo) {
          sessionStorage.setItem('auth0_return_to', appState.returnTo);
        }
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderConfig;
